import appCorporateInvoice from "../../views/appCustomers/corporateHoliday.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("corporateholiday", {
    url: "corporateholiday/:id",
    parent: "app",
    views: {
      view: {
        template: appCorporateInvoice,
      },
    },
    reloadOnSearch: false,
    data: { title: "CorporateHoliday" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/corporateHoliday/corporateHoliday.urls.js